export const weather = {
    "sunny": "clear_day.svg",
    "mostly sunny": "clear_day.svg",
    "partly sunny": "partly_cloudy_day.svg",
    "intermittent clouds": "partly_cloudy_day.svg",
    "hazy sunshine": "haze_day.svg",
    "mostly cloudy": "overcast.svg",
    "cloudy": "overcast.svg",
    "dreary (overcast)": "overcast.svg",
    "fog": "fog.svg",
    "showers": "rain.svg",
    "mostly cloudy w/ showers": "partly_cloudy_day_rain.svg",
    "partly sunny w/ showers": "partly_cloudy_day_rain.svg",
    "t-storms": "thunderstorms.svg",
    "partly sunny w/ t-storms": "thunderstorms_day.svg",
    "rain": "rain.svg",
    "flurries": "snow.svg",
    "mostly cloudy w/ flurries": "partly_cloudy_day_hail.svg",
    "partly sunny w/ flurries": "partly_cloudy_day_hail.svg",
    "snow": "snow.svg",
    "mostly cloudy w/ snow": "snow.svg",
    "ice": "snow.svg",
    "sleet": "sleet.svg",
    "freezing rain": "rain.svg",
    "rain and snow": "sleet.svg",
    "hot": "clear_day.svg",
    "cold": "overcast.svg",
    "windy": "wind.svg",
    "clear": "clear_day.svg",
    "mostly clear": "clear_day.svg",
    "partly cloudy": "partly_cloudy_day.svg",
    "hazy moonlight": "haze_night.svg",
    "partly cloudy w/ showers": "partly_cloudy_day_rain.svg",
    "partly cloudy w/ t-storms": "thunderstorms_day.svg",
    "mostly cloudy w/ t-storms": "thunderstorms.svg",
}